import { createApp } from "vue";
import router from "@/routers";
import pinia from "@/stores";
import App from "./App.vue";

// 神策数据埋点
import "./plugin/sensors";

// scss
import "@/assets/styles/default.scss";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/display.css";
import "@/assets/styles/_flex.scss";
import "@/assets/styles/_spacing.scss";
import "@/assets/iconfont/iconfont.css";
import "zhihao-ui/dist/index.css";
import "@/assets/styles/colors.scss";

import "@/assets/styles/base.scss";

// custom directives
import directives from "@/views/directives/index";

import { TRACK_TYPE } from "@zhihaoscm/meta";
import sensors from "sa-sdk-javascript";

createApp(App).use(directives).use(router).use(pinia).mount("#app");

if (!localStorage.getItem("accessTime")) {
    localStorage.setItem("accessTime", Date.now().toString());
}

const HandleStorage = (event) => {
    if(event.key === 'accessTime' && !localStorage.getItem('accessTime')){
        localStorage.setItem("accessTime", String(Date.now()));
    }
};

window.addEventListener("beforeunload", function () {
    const time = localStorage.getItem("accessTime");
    localStorage.removeItem("accessTime");

    if(!time){
        return
    }

    sensors.track("145", {
        pageDesc: "系统",
        sceneText: "页面停留事件",
        event_duration: (Date.now() - Number(time)) / 1000,
        type: TRACK_TYPE.PAGE_STAY_DURATION.code
    });
});

window.addEventListener("storage", HandleStorage);
